import styled from "styled-components";

export const LogoWrapper = styled.div`
  overflow: hidden;
  max-height: 100px;
  max-width: 180px;

  @media (min-width: 576px) {
    max-height: 120px;
  }
`;
